module.exports = __webpack_public_path__ + "static/media/water_monitoring_zh.6631103e.png";